import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { green } from "@mui/material/colors";
import Confetti from "react-confetti";
import Icon from "../../assets/images/Icon.png";
const plans = [
  {
    name: "Starter",
    features: ["Access to basic features", "Limited support"],
  },
  {
    name: "Pro",
    features: ["Access to all features", "Priority support", "No ads"],
  },
  {
    name: "Expert",
    features: [
      "Access to all features",
      "24/7 support",
      "No ads",
      "Free updates",
    ],
  },
];

const faqs = [
  {
    question: "How do I upgrade my plan?",
    answer: "You can upgrade your plan in the account settings.",
  },
  {
    question: "What if I want to cancel my subscription?",
    answer: "You can cancel your subscription anytime in the account settings.",
  },
  // Add more FAQs as needed
];

const SubscriptionSuccessPage = () => {
  const { plan: planName } = useParams();
  const plan = plans.find(
    (plan) => plan.name.toLowerCase() === planName.toLowerCase()
  );
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [runConfetti, setRunConfetti] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    const confettiTimeout = setTimeout(() => {
      setRunConfetti(false);
    }, 5000); // 5 seconds

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(confettiTimeout);
    };
  }, []);
  return (
    <>
      {runConfetti && <Confetti width={width} height={height} />}
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "30px 0",
        }}
      >
        <img
          onClick={() => {
            window.location.href = "/app/events";
          }}
          src={Icon}
          style={{ margin: 0, width: "200px", cursor: "pointer" }}
        />
      </div>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        p={2}
        position="relative"
      >
        <CheckCircleIcon style={{ fontSize: 100, color: green[500] }} />
        <Typography variant="h4" gutterBottom>
          Subscription Successful!
        </Typography>
        <Typography variant="h5" gutterBottom>
          You've subscribed to the {plan.name} Plan
        </Typography>
        {/* <Typography variant="h6" gutterBottom>
          Plan Features:
        </Typography>
        <List>
          {plan.features.map((feature, index) => (
            <ListItem key={index}>
              <ListItemText primary={feature} />
            </ListItem>
          ))}
        </List> */}
        <Typography variant="h6" gutterBottom>
          FAQs:
        </Typography>
        <List>
          {faqs.map((faq, index) => (
            <ListItem key={index}>
              <ListItemText primary={faq.question} secondary={faq.answer} />
            </ListItem>
          ))}
        </List>
      </Box>
    </>
  );
};

export default SubscriptionSuccessPage;
